module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-u-2-bc5c211bb5675efde1e88accac644c34.svg";